module.exports = __webpack_public_path__ + "img/parking-brake-off.bffc3270.svg";